/**
 * Load Google Ads
 */

require("./adapter")
require("./functions")
require("./event_listeners")
